export default __webpack_public_path__ + "static/media/About-Tower-viajes-0@2x.f983826f.jpg";